// extracted by mini-css-extract-plugin
export default {"footerOrbital":"Orbital_footerOrbital__CRkEe","property":"Orbital_property__nBM-a","text":"Orbital_text__QpAXT"};